import type { EventInfo } from '@models/Event'

import { apiClient } from '../../../gateways/api'
import type { HoofdleidingProject } from '../types/HoofdleidingProject'

export { saveEvent }

const saveEvent = async (data: EventInfo): Promise<HoofdleidingProject> => {
  const { id } = data

  const { data: project } = await apiClient({
    url: `/rest/project/${id}/event`,
    method: 'POST',
    data,
  })

  return project
}
